import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BcmEmployee } from '@shared/models/bcm-employee';
import { BcmDepartment } from '@shared/models/bcm-department';
import { OrderTaskPositionAssigneeType } from '@shared/helpers/order-task-position-assignee.util';
import { resolveOrderEmployeeAssigneeOptionLabel } from '@shared/helpers/order-order-assignee.util';

@Component({
    selector: 'u2b-order-assignee-fields',
    templateUrl: './u2b-order-assignee-fields.component.html',
    styleUrls: ['./u2b-order-assignee-fields.component.scss'],
    standalone: false,
})
export class U2bOrderAssigneeFieldsComponent implements OnInit, OnDestroy {
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() employees: BcmEmployee[] = [];
    @Input() departments: BcmDepartment[] = [];
    @Input() appearance: MatFormFieldAppearance = 'outline';
    @Input() disabled = false;
    /** Abteilung als Zuständigkeit nur anbieten, wenn das Abteilungsmodul gebucht ist. */
    @Input() departmentAssigneeEnabled = true;

    readonly OrderTaskPositionAssigneeType = OrderTaskPositionAssigneeType;

    private readonly destroy$ = new Subject<void>();

    get visibleAssigneeTypes(): OrderTaskPositionAssigneeType[] {
        const types: OrderTaskPositionAssigneeType[] = [OrderTaskPositionAssigneeType.Employee];

        if (this.departmentAssigneeEnabled) {
            types.push(OrderTaskPositionAssigneeType.Department);
            return types;
        }

        if (this.parentFormGroup?.get('assigneeType')?.value === OrderTaskPositionAssigneeType.Department) {
            types.push(OrderTaskPositionAssigneeType.Department);
        }

        return types;
    }

    get showAssigneeTypeField(): boolean {
        return this.departmentAssigneeEnabled
            || this.parentFormGroup?.get('assigneeType')?.value === OrderTaskPositionAssigneeType.Department;
    }

    ngOnInit(): void {
        const assigneeTypeControl = this.parentFormGroup.get('assigneeType');

        assigneeTypeControl?.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((assigneeType: OrderTaskPositionAssigneeType | null) => {
                if (assigneeType !== OrderTaskPositionAssigneeType.Employee) {
                    this.parentFormGroup.patchValue({ bcm_employees_id: null }, { emitEvent: false });
                }

                if (assigneeType !== OrderTaskPositionAssigneeType.Department) {
                    this.parentFormGroup.patchValue({ bcm_departments_id: null }, { emitEvent: false });
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    employeeLabel(employee: BcmEmployee): string {
        return resolveOrderEmployeeAssigneeOptionLabel(employee, this.departments);
    }
}
